
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Card, CardContent, Grid2 } from '@mui/material';
import Container from '@mui/material/Container';




export default function Features() {


  return (
    <React.Fragment>
      <Container maxWidth="xl" sx={{ my: 5 }}>
        <Grid2 container justifyContent={'space-between'} spacing={3}>
          <Grid2 size={{ xs: 12 }}>

            <Typography variant='h4' >Why Callgoose SQIBS Stands Out?
            </Typography>
            <Typography variant='h4' gutterBottom sx={{ fontWeight: 200 }}>
              Key Features and Advantages
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              Callgoose SQIBS is not just another incident management tool; it transforms how businesses manage and respond to operational challenges.
            </Typography>

          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <Typography variant='body1' sx={{fontWeight:500}}>Seamless Integration</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Integrates with tools like Slack, Microsoft Teams, and Callgoose apps to automate incident remediation and cloud operations.
                  Trigger, acknowledge, resolve incidents, and run automation workflows directly from these platforms.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <Typography  variant='body1' sx={{fontWeight:500}}>Future-Ready Automation</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Automates up to 99% of IT incidents depending on the organization's infrastructure, enabling a shift from manual to automated resolutions.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <Typography  variant='body1' sx={{fontWeight:500}}>Incident Auto Remediation</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Automate routine incident support actions without manual input, freeing up IT teams for more complex tasks.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <Typography  variant='body1' sx={{fontWeight:500}}>Event-Driven Automation</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Automatically triggers predefined actions based on events, ensuring a quick response to anomalies.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <Typography  variant='body1' sx={{fontWeight:500}}>IT Request Automation</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Automating IT requests improves efficiency, reducing the workload on IT teams and enhancing service delivery.

                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <Typography  variant='body1' sx={{fontWeight:500}}>On-Call Schedule and Incident Management</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  Offers advanced features for on-call scheduling, real-time incident management, and response, with multi-language support across the globe.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>



        </Grid2>
      </Container>
    </React.Fragment>
  );
}
